// extracted by mini-css-extract-plugin
module.exports = {"PostDetailRight__searchPanel":"nt_a zu_pu zu_ko zu_kp","PostDetailRight__brandDaysPosts":"nt_b zu_pu zu_ko zu_kp"};